import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const productInformation = css`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const productTitle = css`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;

  @media (max-width: ${dimensions.phoneSmallMax}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const marginRight = css`
  margin-right: 0.5rem;
`;
